<template>
  <div id="edp-offers-view">
    <div class="d-flex justify-content-between align-items-center title-block border-bottom ml-3">
      <PageTitleComponent pageTitle="eDP-Aktionen" category="Werbeinhalte" categoryIcon="ad" />
      <CreateEdpOfferComponent />
    </div>
    <div class="pl-3 py-3">
      <div class="mt-2 alert alert-warning" v-if="offers === null">Hier gibt es noch nichts zu sehen. Klicke auf "Erstellen" um das zu ändern. 😉</div>

      <b-tabs v-else-if="Object.keys(offers).length > 0">
        <b-tab title="Aktuell" active v-if="Object.keys(activeOffers).length > 0">
          <table class="table mt-3">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Anzeigezeitraum</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <EdpOfferRowComponent v-for="(item, key) in activeOffers" :key="`edp-offer-${key}`" :item="item" :itemKey="key" v-on:selectedItem="selectItem" />
            </tbody>
          </table>
        </b-tab>
        <b-tab title="Abgelaufen">
          <table class="table mt-3">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Anzeigezeitraum</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <EdpOfferRowComponent v-for="(item, key) in inactiveOffers" :key="`edp-offer-${key}`" :item="item" :itemKey="key" v-on:selectedItem="selectItem" />
            </tbody>
          </table>
        </b-tab>
      </b-tabs>
      <SpinnerComponent class="mt-3" v-else />
    </div>
    <EditEdpOfferComponent 
      :modalId="'edit-edp-offer-modal'" 
      :selectedKey="selectedKey" 
      :selectedItem="selectedItem" />
  </div>
</template>

<script>
import PageTitleComponent from '../components/PageTitleComponent'
import SpinnerComponent from '../components/SpinnerComponent'
import CreateEdpOfferComponent from '../components/CreateEdpOfferComponent'
import EdpOfferRowComponent from '../components/EdpOfferRowComponent'
import EditEdpOfferComponent from '../components/EditEdpOfferComponent'
import moment from 'moment-timezone'

import {db} from "../plugins/firebase"
import { onValue, ref } from "firebase/database"

export default {
  name: 'EdpOffersView',
  components: {
    PageTitleComponent,
    SpinnerComponent,
    CreateEdpOfferComponent,
    EdpOfferRowComponent,
    EditEdpOfferComponent
  },
  methods: {
    selectItem: function(data) {
      this.selectedKey = data.key
      this.selectedItem = data.item
      this.$bvModal.show('edit-edp-offer-modal')
    }
  },
  computed: {
    activeOffers: function() {
      const activeOffers = Object.entries(this.offers).filter(([key, item]) => {
        const nowTimestamp = moment(moment().tz('Europe/Berlin').format('YYYY-MM-DD')).unix()
        const fromTimestamp = moment(item.fromDate).unix()
        const toTimestamp = moment(item.toDate).unix()

        if (
          (fromTimestamp <= nowTimestamp && toTimestamp >= nowTimestamp) ||
          fromTimestamp >= nowTimestamp
        ) {
          return [key, item]
        }  
      })
      activeOffers.sort((a, b) => new Date(b[1].toDate) - new Date(a[1].toDate))
      return Object.fromEntries(activeOffers)
    },
    inactiveOffers: function() {
      const inactiveOffers = Object.entries(this.offers).filter(([key, item]) => {
        const nowTimestamp = moment(moment().tz('Europe/Berlin').format('YYYY-MM-DD')).unix()
        const toTimestamp = moment(item.toDate).unix()

        if (toTimestamp < nowTimestamp) {
          return [key, item]
        }  
      })
      inactiveOffers.sort((a, b) => new Date(b[1].toDate) - new Date(a[1].toDate))
      return Object.fromEntries(inactiveOffers)
    }
  },
  mounted() {
    onValue(ref(db, 'edpOffers'), snapshot => {
      this.offers = snapshot.val()
    })
  },
  data() {
    return {
      offers: [],
      selectedKey: '',
      selectedItem: {}
    }
  }
}
</script>

<style scoped>
#edp-offers-view {
  margin-left: 250px;
}
.title-block {
  height: 120px;
}
</style>